var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimerange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.72091C12 6.47291 12 6.34791 12.057 6.24591C12.1095 6.15877 12.1873 6.08969 12.28 6.04791C12.388 6.00391 12.498 6.01791 12.718 6.04391C13.703 6.1628 14.6432 6.52409 15.4543 7.09546C16.2655 7.66683 16.9223 8.43043 17.3659 9.31789C17.8095 10.2054 18.0262 11.189 17.9964 12.1807C17.9666 13.1724 17.6914 14.1413 17.1953 15.0006C16.6992 15.8598 15.9978 16.5826 15.1539 17.1043C14.3099 17.626 13.3498 17.9303 12.3594 17.9899C11.369 18.0494 10.3793 17.8625 9.47893 17.4458C8.57852 17.029 7.79551 16.3955 7.20001 15.6019C7.06701 15.4239 7.00001 15.3349 6.98501 15.2199C6.97465 15.1184 6.99558 15.0162 7.04501 14.9269C7.10501 14.8269 7.21201 14.7649 7.42701 14.6409L11.64 12.2089C11.771 12.1329 11.837 12.0949 11.884 12.0419C11.9253 11.9943 11.9572 11.9394 11.978 11.8799C12 11.8129 12 11.7369 12 11.5849V6.72091Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5Z",
    stroke: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerange);
export default __webpack_public_path__ + "static/media/Time range.3dd689f39ca1688562746cb535ee47ef.svg";
export { ForwardRef as ReactComponent };